import React from "react";

// Helpers
import { getLocalStorage, setLocalStorage } from "../helpers/appHelper";

// Auth Context
export const AuthContext = React.createContext();

// Auth Provider
export const AuthProvider = ({ children }) => {
  // Auth State
  const [auth, setAuth] = React.useState(() => {
    return {
      token: getLocalStorage("token"),
      user: getLocalStorage("user"),
    };
  });

  React.useEffect(() => {
    setLocalStorage("token", auth.token);
    setLocalStorage("user", auth.user);
  }, [auth]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
